import Head from "next/head"
import { ReactNode } from "react"

type PageHeaderProps = {
  title: string
  children?: ReactNode
}

export const PageHeader = ({ title, children }: PageHeaderProps) => {
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>

      <div id="header-bar" className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>

        {children}
      </div>
    </>
  )
}
